import { QueryClient, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { TruckEntity } from 'src/entities/Truck.entity';
import { TruckEntity as V2TruckEntity } from 'src/entities/truckEntity';

const requestPathBase = '/api/v3/trucks';
const queryPrefix = 'useTrucksQuery';

const getAll = (queryClient: QueryClient, on: string, allVisible?: boolean) => async () => {
  const requestPath = `${requestPathBase}?on=${on}&all_visible=${String(!!allVisible)}`;
  const axiosResponse = await axios.get<TruckEntity[]>(requestPath);
  const entities = axiosResponse.data;

  return entities.map((it) => {
    queryClient.setQueryData([queryPrefix, { id: it.id }], it);

    return it;
  });
};

export const useTrucksQuery = (on: string, params: { enabled: boolean, allVisible?: boolean }) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: [queryPrefix, on, params.allVisible],
    queryFn: getAll(queryClient, on, params.allVisible),
    enabled: params.enabled,
    staleTime: Infinity
  });
};

const getTruck = (id: number) => async () => {
  const res = await axios.get<V2TruckEntity>(`/api/v2/trucks/${id}`);
  return res.data;
};

export const useTruckQuery = (id: number) => useQuery({
  queryKey: ['trucks', { id }],
  queryFn: getTruck(id),
  staleTime: Infinity,
  enabled: Boolean(id)
});
